<template>
  <div class="container">
    <div class="jumbotron m-3">
      <div class="col-md-12 mx-auto">
        <h3 class="text-center">Introdução</h3>
      </div>
      <p class="text-center">
        Aqui você terá um passo-a-passo de cada ação do sistem.
      </p>
      <p class="text-center">
        Abaixo temos alguns tópicos do que pode ser feito aqui, você pode clicar
        em um dos seguintes itens: Listar Notícias, Criar Notícias,
        Editar Notícias e Excluir Notícias.
      </p>
      <p class="text-center">
        Ao fazer isso, será exibido informações de como utilizar cada item.
      </p>
      <div class="border border-dark rounded">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" data-toggle="tab" href="#listar"
              >Listar Notícias</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#cadastrar"
              >Cadastrar Notícia</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#editar"
              >Editar Notícia</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#excluir"
              >Excluir Notícia</a
            >
          </li>
        </ul>

        <div class="tab-content">
          <div id="listar" class="container tab-pane active">
            <div class="mt-3">
            <p>
              Para entrar na página de Listar Notícia, você deverá estar logado
              e então clicar em Listar Notícias na barra de navegação.
            </p>
            <p>
              Feito isso, irá aparecer esta tela:
            </p>
              <img
                class="border border-dark img-fluid"
                src="../assets/images/listar_noticia_page.jpg"
                width="600"
                alt="Lista Noticias"
              />
              <p>
                Numerei os itens para facilitar a identificação:
                <ol>
                  <li>Barra de Pesquisa</li>
                  <li>Botão para Cadastrar Notícias</li>
                  <li>Lista das Notícias</li>
                  <li>Botão para Editar uma Notícia</li>
                  <li>Botão para Excluir uma Notícia</li>
                </ol>
              </p>
          </div>
          </div>
          <div id="cadastrar" class="container tab-pane">
            <div class="mt-3">
            <p>
              Este é o segundo item da lista de notícia:
            </p>
            <img
                class="border border-dark img-fluid"
                src="../assets/images/cadastrar_noticia_page.jpg"
                width="600"
                alt="Cadastrar Noticias"
              />
              <p>
                Nesta tela, é obrigatório o preenchimento de todos os campos:
                <ul>
                  <li>Título</li>
                  <li>Assunto</li>
                  <li>Categoria</li>
                  <li>Imagem Principal</li>
                  <li>Mensagem</li>
                </ul>
              </p>
              <p>
                 Ao clicar no botão: <button class="btn btn-primary">Cadastrar</button> quando estiver naquela tela, você irá cadastrar aquela notícia.
              </p>
          </div>
          </div>
          <div id="editar" class="container tab-pane">
            <div class="mt-3">
            <p>
              Este é o quarto item da lista de notícia:
            </p>
              <img
                class="border border-dark img-fluid"
                src="../assets/images/editar_noticia_page.jpg"
                width="600"
                alt="Editar Noticias"
              />
              <p class="mt-2">
                 Ao clicar no botão: <button class="btn btn-primary">Salvar</button> quando estiver naquela tela, você irá salvar as edições daquela notícia.
              </p>
          </div>
          </div>
          <div id="excluir" class="container tab-pane">
            <div class="mt-3">
            <p>
              Este é o quinto item da lista de notícia:
            </p>
              <img
                class="border border-dark img-fluid"
                src="../assets/images/deletar_noticia_page.jpg"
                width="600"
                alt="Deletar Noticias"
              />
              <p>
                É uma confirmação para deletar uma notícia, para evitar que delete sem querer...
              </p>
              <p>
                Ao clicar no botão: <button class="btn btn-danger">Sim</button> quando estiver naquela tela, você irá deletar aquela notícia.
              </p>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import EventBus from "./EventBus";
export default {
  data(){return{}}
}
</script>
<style scoped>
.fa-trash {
  color: red;
}
.fa-trash:hover {
  color: darkred;
}
.fa-plus {
  color: green;
}
.fa-plus:hover {
  color: darkgreen;
}
</style>



// WEBPACK FOOTER //
// src/components/Tutorial.vue